export default {
    tooltipAdmin: 'This macro-trend is no longer part of the current Trendone trend universe.',
    tooltipSuccessor: ' Activate its descendant now: {title}',
    tooltipUser: 'This macro-trend is no longer part of the current Trendone trend universe.'
}
